import axios from "../../axiosDod.js";
const getDodEmployees = async ({ commit }, data) => {
  const params = { limit: Number.MAX_SAFE_INTEGER };
  if (data) {
    const { statusId, search, filters, limit, page, sortBySettlement } = data;
    if (statusId) {
      params.employeesStatusesIds = statusId;
    }
    if (search) {
      params.search = search;
    }
    if (filters) {
      for (const [key, value] of Object.entries(filters)) {
        params[key] = value;
      }
    }
    if (limit) {
      params.limit = limit;
    }
    if (page) {
      params.page = page;
    }
    if (sortBySettlement) {
      params.sortBySettlement = true;
    }
  }

  const employees = await axios.get(`employees`, { params });
  commit("SET_DOD_EMPLOYEES", employees.data);
};

const getDodEmployeesInMonth = async ({ commit }, data) => {
  const { month, year, filters, search, limit, page } = data;
  const params = { limit: Number.MAX_SAFE_INTEGER, month, year };
  if (search) {
    params.search = search;
  }
  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      params[key] = value;
    }
  }
  if (limit) {
    params.limit = limit;
  }
  if (page) {
    params.page = page;
  }
  const response = await axios.get(`employees/byMonth`, { params });
  commit("SET_DOD_EMPLOYEES_IN_MONTH", response.data);
};

const addEmployee = async ({ dispatch }, data) => {
  const response = await axios.post(`employees`, data);
  dispatch("fetchStatusesCounters");
  return response.data;
};

// Sprawdzenie przed dodaniem: czy opiekun o tym numerze PESEL już jest w bazie.
// Zwraca znaleziony rekord albo null. Błąd samego sprawdzenia nie blokuje dodawania -
// po stronie backendu i tak stoi blokada na zapisie.
const checkEmployeeDuplicate = async (_, data) => {
  try {
    const response = await axios.post(`employees/checkDuplicate`, data);
    return response?.data?.duplicate || null;
  } catch (error) {
    console.log(error);
    return null;
  }
};

const removeEmployee = async (_, employeeId) => {
  try {
    const response = await axios.delete(`employees/${employeeId}`);
    return response.data;
  } catch (error) {
    console.log(error);
    throw error;
  }
};

const getEmployeeDetails = async ({ commit, getters, dispatch }, payload) => {
  const { employeeId, ordersMonth, ordersYear } = payload;
  let params = { search: employeeId, withDetails: true };
  const employeeFetchParams = getters.getDodEmployeeFetchParams;
  if (ordersMonth) {
    params.ordersMonth = ordersMonth;
  } else if (employeeFetchParams.ordersMonth) {
    params.ordersMonth = employeeFetchParams.ordersMonth;
  }
  if (ordersYear) {
    params.ordersYear = ordersYear;
  } else if (employeeFetchParams.ordersYear) {
    params.ordersYear = employeeFetchParams.ordersYear;
  }

  const response = await axios.get(`employees/${employeeId}`);
  if (response && response.data && response.data) {
    commit("SET_DOD_SELECTED_EMPLOYEE", response.data);
    if (ordersMonth && ordersYear) {
      commit("SET_EMPLOYEE_FETCH_PARAMS", { ordersMonth, ordersYear });
    }
    await dispatch("getEmployeePaymentForMonth", {
      employeeId,
      year: params.ordersYear || null,
      month: params.ordersMonth || null,
    });
  }
};

const setEmployeeFetchParams = async ({ commit }, data) => {
  commit("SET_EMPLOYEE_FETCH_PARAMS", data);
};

const getEmployeeMessages = async ({ commit }, payload) => {
  const { employeeId, selectedTab } = payload;
  let params = { employeeId, limit: Number.MAX_SAFE_INTEGER };
  if (selectedTab && selectedTab !== "ALL") {
    if (selectedTab === "Komentarze") {
      params.isAction = false;
    }
    if (selectedTab === "Aktywność") {
      params.isAction = true;
    }
  }
  const response = await axios.get(`messages`, {
    params,
  });
  commit("SET_DOD_SELECTED_EMPLOYEE_MESSAGES", response.data);
};

const getEmployeeOrders = async ({ commit }, payload) => {
  const { employeeId, ordersMonth, ordersYear } = payload;
  const response = await axios.get(`orders`, {
    params: {
      withDetails: true,
      ordersMonth,
      ordersYear,
      employeeId,
      limit: Number.MAX_SAFE_INTEGER,
    },
  });
  commit("SET_DOD_SELECTED_EMPLOYEE_ORDERS", response.data);
};

const getEmployeeAvailability = async ({ commit }, payload) => {
  const { employeeId } = payload;
  const response = await axios.get(`employeeAvailability`, {
    params: { employeeId, limit: Number.MAX_SAFE_INTEGER },
  });
  commit("SET_DOD_SELECTED_EMPLOYEE_AVAILABILITY", response.data);
};

const getEmployeeAbsences = async ({ commit }, payload) => {
  const { employeeId } = payload;
  const response = await axios.get(`employeeAbsences`, {
    params: { employeeId, limit: Number.MAX_SAFE_INTEGER },
  });
  commit("SET_DOD_SELECTED_EMPLOYEE_ABSENCES", response.data);
};

const resetEmployeeDetails = async ({ commit }) => {
  commit("SET_DOD_SELECTED_EMPLOYEE", null);
};

const editDodEmployee = async ({ dispatch }, payload) => {
  try {
    const { data, employeeId } = payload;
    await axios.put(`employees/${employeeId}`, data);
    dispatch("fetchStatusesCounters");
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const editEmployeeSchedule = async (_, payload) => {
  try {
    const { data, employeeAvailabilityId } = payload;
    await axios.put(`employeeAvailability/${employeeAvailabilityId}`, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const getEmployeePaymentForMonth = async ({ commit }, data) => {
  try {
    const { employeeId, year, month } = data;
    const params = { employeeId, year, month };
    const response = await axios.get(`employees/paymentForMonth`, { params });
    if (response?.data) {
      commit("SET_DOD_SELECTED_EMPLOYEE_PAYMENT", response.data.sumOfPayments);
    }
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const addEmployeeAbsences = async (_, data) => {
  try {
    await axios.post(`employeeAbsences`, data);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const deleteEmployeeAbsence = async (_, absenceId) => {
  try {
    await axios.delete(`employeeAbsences/${absenceId}`);
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const getDodEmployeesPrimaryInfo = async ({ commit, dispatch }) => {
  const employees = await dispatch("getDodUsers", { role: "EMPLOYEE" });
  commit("SET_DOD_EMPLOYEES_PRIMARY_INFO", employees);
};

const editDodEmployeeNote = async (_, data) => {
  try {
    await axios.put(`employees/${data.id}`, {
      employeeNote: data.note || "",
    });
    return true;
  } catch (error) {
    console.log(error);
    return false;
  }
};

const getEmployeeAttachments = async ({ commit }, payload) => {
  const { employeeId } = payload;
  const response = await axios.get(`employees/${employeeId}/files`);
  commit("SET_DOD_SELECTED_EMPLOYEE_ATTACHMENTS", response.data);
};

const getEmployeeNumberScheduledHoursInMonth = async ({ commit }, payload) => {
  const { employeeId, month, year } = payload;
  const response = await axios.get(
    `employees/${employeeId}/scheduledHoursInMonth`,
    { params: { month, year } }
  );
  commit("SET_DOD_EMPLOYEE_SCHEDULED_HOURS", response.data);
  return response.data;
};

const getEmployeeBills = async ({ commit }, payload) => {
  const { employeeId } = payload;
  const response = await axios.get(`employees/${employeeId}/bills`);
  commit("SET_DOD_EMPLOYEE_BILLS", response.data);
};

// Eksport PEŁNEJ listy opiekunów do XLS - te same parametry co tabela na zakładce Opiekunowie
// (miesiąc, wyszukiwarka, filtry), ale bez limit/page: backend zwraca wszystkie strony.
const generateEmployeesXlsxReport = async (_, data) => {
  const { month, year, search, filters } = data;
  const params = { month, year };
  if (search) {
    params.search = search;
  }
  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      params[key] = value;
    }
  }

  const response = await axios.get(`employees/reports/xlsx`, {
    params,
    responseType: "blob",
  });
  return response?.data;
};

// Zestawienie z zakładki Rozliczenia - te same parametry co tabela, backend zwraca wszystkie strony.
const generateSettlementsXlsxReport = async (_, data) => {
  const { month, year, search, filters } = data;
  const params = { month, year };
  if (search) {
    params.search = search;
  }
  if (filters) {
    for (const [key, value] of Object.entries(filters)) {
      params[key] = value;
    }
  }

  const response = await axios.get(`employees/reports/settlements/xlsx`, {
    params,
    responseType: "blob",
  });
  return response?.data;
};

export default {
  getDodEmployees,
  generateEmployeesXlsxReport,
  generateSettlementsXlsxReport,
  addEmployee,
  checkEmployeeDuplicate,
  editDodEmployee,
  getEmployeeDetails,
  resetEmployeeDetails,
  editEmployeeSchedule,
  getEmployeePaymentForMonth,
  addEmployeeAbsences,
  deleteEmployeeAbsence,
  getEmployeeMessages,
  getEmployeeOrders,
  getEmployeeAbsences,
  getEmployeeAvailability,
  getDodEmployeesPrimaryInfo,
  getDodEmployeesInMonth,
  editDodEmployeeNote,
  getEmployeeAttachments,
  removeEmployee,
  setEmployeeFetchParams,
  getEmployeeNumberScheduledHoursInMonth,
  getEmployeeBills,
};
